import React, { useState, useEffect, useReducer } from 'react';
import CN from 'classnames';
import { DOM_ID } from '@UILayer/UILayer.types';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getGlobalStyles } from '@Managers/Redux/AppState/AppState';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EButtonEvents } from '@Managers/Events/ButtonEvents';

// SVG
import { useTranslation } from 'react-i18next';
import { KeyboardEventCheck } from '@Tools/KeyboardEventCheck';

const TakeButton: React.FC<{ uiFreeze: boolean }> = ({ uiFreeze }) => {
    const [state, setState] = useReducer((state: {}, newState: any) => ({ ...state, ...newState }), {});

    const { t } = useTranslation();
    const globalStyles = useAppSelector(getGlobalStyles);

    const buttonCN = CN(
        styles.take_btn,
        styles.gameplay_btn,
        styles.gameplay_btn_type2,
        globalStyles.orientation,
        globalStyles.wcaMode,
        uiFreeze ? styles.disabled : null
    );

    useEffect(() => {}, []);

    function buttonAction(e: React.MouseEvent<any>) {
        if (!uiFreeze) {
            if (e) e.stopPropagation();
            EventsCenter.emit(EButtonEvents.TAKE_BUTTON_PRESSED);
        }
    }

    return (
        <button
            tabIndex={0}
            className={buttonCN}
            id={DOM_ID.BUTTON_TAKE}
            aria-description={t('WCA_TAKE_BUTTON')}
            onPointerDown={(e) => buttonAction(e)}
            onKeyDown={(e) => KeyboardEventCheck(e, buttonAction)}
        ></button>
    );
};

export default TakeButton;
